export default __webpack_public_path__ + "static/highlight-69aba51c45572f426cea8cfa54f5b300.jpg";